var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#959DA8",
    stroke: "#959DA8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.825,
    d: "m8.002 2.128 3.58 1.93c.419.226.419.87 0 1.095l-3.58 1.93c-.319.17-.693.17-1.012 0l-3.58-1.93c-.418-.226-.418-.87 0-1.095l3.58-1.93c.32-.17.693-.17 1.012 0M2.882 6.456 6.21 8.123c.412.209.676.632.676 1.094v3.146a.61.61 0 0 1-.885.545L2.673 11.24a1.23 1.23 0 0 1-.676-1.094V7a.61.61 0 0 1 .885-.545M12.111 6.456 8.784 8.123a1.23 1.23 0 0 0-.677 1.094v3.146a.61.61 0 0 0 .886.545l3.327-1.667c.413-.209.677-.632.677-1.094V7a.61.61 0 0 0-.886-.545"
  })));
};
export default SvgDollarCircle;